<div id="box" class="slidershow ">
  <div class="slides">

    <input type="radio" name="r" id="r{{i}}" *ngFor="let n of [].constructor(totalNumberOfSlides),let i = index">

    <div class="columns slide s1 dashboard-img dashboard-menu-bauakten">
      <div class="column is-1"></div>
        <div class="column" style="text-align: left;padding-top: 5%">
            <div class="columns">
                <div class="column">
                    <h1 style="color: #FFFFFF; font-size: 45px; font-weight: bold;">Bauaktenarchivbesuche</h1>
                    <div class="subtitle is-size-3" style="color: #fff">
                        Jetzt mit DocEstate GO
                    </div>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <a href="https://www.docestate.com/go/" target="_blank">
                        <button class="dashboard-button has-text-centered">Jetzt Mehr Erfahren</button>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="columns slide dashboard-img dashboard-menu-digitiz">
      <div class="column is-1"></div>
        <div class="column" style="text-align: left;padding-top: 5%">
            <div class="columns">
                <div class="column">
                    <h1 style="color: #FFFFFF; font-size: 45px; font-weight: bold;">Digitalisierungsservice</h1>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <a href="https://www.docestate.com/digitalisierungsservice-3/" target="_blank">
                        <button class="dashboard-button has-text-centered">Jetzt Mehr Erfahren</button>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="columns slide dashboard-img  dashboard-menu-leitung">
      <div class="column is-1"></div>
        <div class="column" style="text-align: left;padding-top: 5%">
            <div class="columns">
                <div class="column">
                    <h1 style="color: #FFFFFF; font-size: 45px; font-weight: bold;">Leitungsauskünfte</h1>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <a href="https://www.docestate.com/leitungsauskunfte/" target="_blank">
                        <button class="dashboard-button has-text-centered">Jetzt Mehr Erfahren</button>
                    </a>
                </div>
            </div>
        </div>
    </div>
  </div>
  <div class="navigation1">
      <label (click)="switchSlide(i)" for="r{{i}}" *ngFor="let n of [].constructor(totalNumberOfSlides),let i = index" class="bar" [ngClass]="{'selected':sliderIndex === i}"></label>
  </div>
  <div>
    <div (click)="arrowSlide(sliderIndex-2)" class="is-clickable" style="position: absolute;top: 50%;left: 1%">
      <svg xmlns="http://www.w3.org/2000/svg" width="31.278" height="59.557" viewBox="0 0 31.278 59.557">
        <path id="Pfad_562" data-name="Pfad 562" d="M45.657,67.314,18,39.657,45.657,12" transform="translate(-16.5 -9.879)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"/>
      </svg>
    </div>

    <div (click)="arrowSlide(sliderIndex)" class="is-clickable" style="position: absolute;top: 50%;right: 1%">
      <svg xmlns="http://www.w3.org/2000/svg" width="31.278" height="59.557" viewBox="0 0 31.278 59.557">
        <path id="Pfad_562" data-name="Pfad 562" d="M18,67.314,45.657,39.657,18,12" transform="translate(-15.879 -9.879)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"/>
      </svg>
    </div>
  </div>
</div>
<div class="navigation">

  <div *ngIf="platformProfile && (platformProfile.platformType === 'CONNECT' || platformProfile.platformType === 'MANDATE') && isAdmin() else otherColumns">

    <div class="columns" style="margin-top: 2rem">
      <div class="column is-one-third has-text-centered">
        <a routerLink="/new_order" style="cursor: pointer">
          <!--Neu Auftrag-->
          <div class="columns">
            <div class="column">
              <button class="shape">
                <img src="assets/images/dashboard_icon/komprimiert/neuer_antrag.png" alt="" style="z-index: 1; height: 90%; float: left; box-shadow: 0 2px 7px 4px rgba(0, 0, 0, 0.2); border-radius: 60px">
                <div style="display: flex;height: 90%; justify-content: center; align-items: center">
                  <p>Neuer Auftrag</p>
                </div>
              </button>
            </div>
          </div>
        </a>
      </div>

      <div class="column is-one-third"></div>

      <div class="column is-one-third has-text-centered">
        <a style="cursor: pointer" routerLink="/order">
          <!-- Bestellübersicht-->
          <div class="columns">
            <div class="column">
              <button class="shape">
                <img src="assets/images/dashboard_icon/komprimiert/bestellübersicht.png" alt="" style="z-index: 1; height: 90%; float: left; box-shadow: 0 2px 7px 4px rgba(0, 0, 0, 0.2); border-radius: 60px">
                <div style="display: flex;height: 90%; justify-content: center; align-items: center">
                  <p>Bestellübersicht</p>
                </div>
              </button>
            </div>
          </div>
        </a>
      </div>

    </div>

      <div class="columns" *ngIf="platformProfile && (platformProfile.pricing?.additionalPositions['ownre'] || platformProfile.platformType === 'CONNECT') && isAdmin()">
        <div class="column is-one-third has-text-centered"
             [attr.title]="!platformProfile.pricing?.additionalPositions['ownre'] ? 'Zum aktivieren wenden sie sich bitte an Ihren Sachbearbeiter.' : null">
          <a style="cursor: pointer" routerLink="/owner-research" [ngClass]="{'disabled-block': !platformProfile.pricing?.additionalPositions['ownre']}" >
            <div class="columns">
              <div class="column">
                <button class="shape is-align-items-center">
                  <img src="assets/images/dashboard_icon/ownerresearch-icon.png"
                       alt="" style="z-index: 1; height: 90%; float: left; box-shadow: 0 2px 7px 4px rgba(0, 0, 0, 0.2); border-radius: 60px;  ">
                  <div style="display: flex;height: 90%; justify-content: center; align-items: center" >
                    <p>Eigentümerrecherche</p>
                  </div>
                </button>
              </div>
            </div>
          </a>
        </div>


        <div class="column is-one-third"></div>

        <div class="column is-one-third has-text-centered">
          <a style="cursor: pointer" routerLink="/saved-properties">
            <!-- Bestellübersicht-->
            <div class="columns">
              <div class="column">
                <button class="shape">
                  <img src="assets/images/dashboard_icon/komprimiert/object_overview.png" alt="" style="z-index: 1; height: 90%; float: left; box-shadow: 0 2px 7px 4px rgba(0, 0, 0, 0.2); border-radius: 60px">
                  <div style="display: flex;height: 90%; justify-content: center; align-items: center">
                    <p>Objektübersicht</p>
                  </div>
                </button>
              </div>
            </div>
          </a>
        </div>

      </div>




  </div>


  <ng-template #otherColumns>
    <div class="columns" style="margin-top: 2rem">
      <div class="column is-one-third has-text-centered">
        <a routerLink="/new_order" style="cursor: pointer">
          <!--Neu Auftrag-->
          <div class="columns">
            <div class="column">
              <button class="shape">
                <img src="assets/images/dashboard_icon/komprimiert/neuer_antrag.png" alt="" style="z-index: 1; height: 90%; float: left; box-shadow: 0 2px 7px 4px rgba(0, 0, 0, 0.2); border-radius: 60px">
                <div style="display: flex;height: 90%; justify-content: center; align-items: center">
                  <p>Neuer Auftrag</p>
                </div>
              </button>
            </div>
          </div>
        </a>
      </div>

      <div class="column is-one-third"></div>

      <div class="column is-one-third has-text-centered">
        <a style="cursor: pointer" routerLink="/order">
          <!-- Bestellübersicht-->
          <div class="columns">
            <div class="column">
              <button class="shape">
                <img src="assets/images/dashboard_icon/komprimiert/bestellübersicht.png" alt="" style="z-index: 1; height: 90%; float: left; box-shadow: 0 2px 7px 4px rgba(0, 0, 0, 0.2); border-radius: 60px">
                <div style="display: flex;height: 90%; justify-content: center; align-items: center">
                  <p>Bestellübersicht</p>
                </div>
              </button>
            </div>
          </div>
        </a>
      </div>
    </div>

    <div class="columns" *ngIf="platformProfile && platformProfile.pricing?.additionalPositions['ownre'] && isAdmin()">
      <div class="column is-one-third has-text-centered"
           [attr.title]="!platformProfile.pricing?.additionalPositions['ownre'] ? 'Zum aktivieren wenden sie sich bitte an Ihren Sachbearbeiter.' : null">
        <a style="cursor: pointer" routerLink="/owner-research">
          <div class="columns">
            <div class="column">
              <button class="shape is-align-items-center">
                <img src="assets/images/dashboard_icon/ownerresearch-icon.png"
                     alt="" style="z-index: 1; height: 90%; float: left; box-shadow: 0 2px 7px 4px rgba(0, 0, 0, 0.2); border-radius: 60px;  ">
                <div style="display: flex;height: 90%; justify-content: center; align-items: center" >
                  <p>Eigentümerrecherche</p>
                </div>
              </button>
            </div>
          </div>
        </a>
      </div>
    </div>

  </ng-template>


  <div class="columns" style="margin: 50px 0 50px">

    <div class="column"></div>
    <div class="column has-text-centered"><h1 class="" style="font-size: 40px; font-weight: bold; color: #336e99">Ihre
      Performance</h1></div>
    <div class="column"></div>

  </div>

    <div class="container">
        <div class="columns">
            <div class="column has-text-centered card has-round-border" style="margin: 40px; height: 100%">
                <div>
                    <img src="assets/images/dashboard_icon/komprimiert/gesparte_kosten.png" alt="" style="width: 35%;">
                </div>
                <p style="color: #35566E; font-size: 25px">Gesparte Kosten</p>
                <div *ngIf="!loadingPerformance else noTime" class="card has-round-border">
                    <p style="color: #35566E; font-size: 35px">{{calculateCostPerformance(numberOfDocuments, numberOfSpecialDocuments, numberOfBauaktenDocuments) | currency:'EUR'}}</p>
                </div>
            </div>

            <div class="column has-text-centered card has-round-border" style="margin: 40px;height: 100%">
                <div style="position: absolute; right: 5%">
                    <a (click)="displaySavedTimeInformationModal()">Info</a>
                </div>
                <div>
                    <img src="assets/images/dashboard_icon/komprimiert/gesparte_zeit.png" alt="" style="width: 35%">
                </div>
                <p style="color: #35566E; font-size: 25px">Gesparte Zeit</p>
                <div class="card has-round-border" *ngIf="!loadingPerformance else noTime">
                    <p style="color: #35566E; font-size: 35px">{{calculateSavedTimePerformance(numberOfDocuments, numberOfSpecialDocuments) | number:'1.2-2':'de'}}
                        h</p>
                </div>
            </div>

            <div class="column has-text-centered card has-round-border" style="margin: 40px;height: 100%">
                <div style="position: absolute; right: 5%">
                    <a (click)="displayCoInformationModal()">Info</a>
                </div>
                <div>
                    <img src="assets/images/dashboard_icon/komprimiert/co2.png" alt="" style="width: 35%">
                </div>
                <p style="color: #35566E; font-size: 25px">Gespartes CO2</p>
                <div class="card has-round-border" *ngIf="!loadingPerformance else noTime">
                    <p style="color: #35566E; font-size: 35px">{{calculateCOPerformance(numberOfDocuments, numberOfBauaktenDocuments, 0.055) | number:'1.2-2':'de'}}
                        kg</p>
                </div>
            </div>
        </div>
    </div>

    <ng-template #noTime>
        <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'85%'}" appearance="line" count="1"></ngx-skeleton-loader>
    </ng-template>

  <app-modal id="co-modal" [active]="showCoInformationModal" (modalClosed)="showCoInformationModal = false">
    <div class="title is-5">CO2 - Berechnung</div>
    <div class="columns">
      <div class="column">
        <p>
          Die Angaben beruhen auf Durchschnittswerten. Die Durchschnittswerte belaufen sich dabei auf einen herkömmlichen Standardbrief (11 x 22 cm) und 7 Seiten pro Auskunft.
          Jedes Blatt verursacht dabei durchschnittlich 5g CO2 zzgl. einmalig 20g CO2 pro Brieftransport. Somit ergeben sich durchschnittlich 55g CO2 pro Auskunft.
        </p>
      </div>
    </div>
  </app-modal>

  <app-modal id="saved-time-modal" [active]="showSavedTimeInformationModal" (modalClosed)="showSavedTimeInformationModal = false">
    <div class="title is-5">Gesparte Zeit - Berechnung</div>
    <div class="columns">
      <div class="column">
        <p>
          Die Angaben beruhen auf Durchschnittswerten für eine Standardauskunft von 2,7h und eine Sonderauskunft von 5h.
        </p>
        <p>&nbsp;</p>
        <p>
          Der angegebene Zeitaufwand setzt sich aus folgenden Parametern zusammen:
        </p>
        <p>&nbsp;</p>
        <ul style="list-style: disc;padding-left: 30px">
          <li>Kontaktrecherche der zuständigen Mitarbeiter</li>
          <li>Vollmachterstellung</li>
          <li>Antragerstellung</li>
          <li>Beschaffung von Nachweisen des berechtigten Interesses</li>
          <li>Einordnung der Liegenschaft auf Katasterkarte mittels Geodaten</li>
          <li>Nachfassen unbeantworteter Anfragen</li>
          <li>Digitalisieren der physischen Auskunftsunterlagen</li>
          <li>Buchen und zahlen des Gebührenbescheides</li>

        </ul>
      </div>
    </div>
  </app-modal>

</div>
